import React from "react";
import { Navigate } from "react-router-dom";
import {
  isAuthenticated,
  isInvestor,
  getUserRole,
} from "../services/authService";

function InvestorProtectedRoute({ children }) {
  // Check authentication status for investors
  if (!isAuthenticated()) {
    return <Navigate to="/investor-login" replace />;
  }

  // Check if user is investor
  if (!isInvestor()) {
    const userRole = getUserRole();
    console.log(
      "InvestorProtectedRoute: User role is",
      userRole,
      "but investor required"
    );

    // If user is admin, redirect to admin dashboard
    if (userRole === "admin") {
      return <Navigate to="/dashboard" replace />;
    }

    // For other roles or no role, redirect to investor login
    return <Navigate to="/investor-login" replace />;
  }

  return children;
}

export default InvestorProtectedRoute;
